import { Link } from "@tanstack/react-router";
import { motion } from "motion/react";

export function LFooter() {
  return (
    <footer className="py-12 bg-[#0a0a0a] border-t border-[#9B87F5]/10">
      <div className="max-w-6xl mx-auto px-6">
        <div className="flex flex-col md:flex-row items-center justify-between gap-8">
          {/* Logo */}
          <div className="flex items-center gap-4">
            <pre className="font-mono text-[#9B87F5] text-[8px] leading-[1]">
              {`██╗     
██║     
██║     
██║     
███████╗
╚══════╝`}
            </pre>
            <div>
              <span className="text-white font-mono text-lg">L</span>
              <p className="text-[#8E9196] text-xs font-mono">
                // link shortener
              </p>
            </div>
          </div>

          {/* Links */}
          <nav className="flex items-center gap-6 font-mono text-sm">
            <Link
              to="/"
              className="text-[#8E9196] hover:text-[#9B87F5] transition-colors"
            >
              HOME
            </Link>
            <Link
              to="/sign-in"
              className="text-[#8E9196] hover:text-[#9B87F5] transition-colors"
            >
              SIGN_IN
            </Link>
            <Link
              to="/sign-up"
              className="text-[#8E9196] hover:text-[#9B87F5] transition-colors"
            >
              SIGN_UP
            </Link>
          </nav>

          {/* ASCII decoration */}
          <div className="text-center md:text-right">
            <pre className="font-mono text-[#9B87F5]/30 text-[8px] inline-block">
              {`┌─────────────────┐
│ © 2024 L        │
│ All rights      │
│ reserved.       │
└─────────────────┘`}
            </pre>
          </div>
        </div>

        {/* Bottom ASCII */}
        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          className="mt-8 text-center"
        >
          <pre className="font-mono text-[#9B87F5]/20 text-[8px] inline-block">
            {`
════════════════════════════════════════════════════════════════════════════════
                              END_OF_TRANSMISSION
════════════════════════════════════════════════════════════════════════════════
`}
          </pre>
        </motion.div>
      </div>
    </footer>
  );
}
